import * as OrderSummary from './components/OrderSummary/OrderHeader/OrderHeader.css';
import * as Traveller from './components/Traveller/Traveller.css';
import * as SocialButton from './components/Account/SocialButton/SocialButton.css';
import * as Sidebar from './components/Sidebar/Sidebar.css';
import * as MobileMenu from './components/Sidebar/MobileMenu/MobileMenu.css';
import InfoCard from './components/InfoCard/InfoCard.css';
import LoyaltyConnect from './components/Loyalty/LoyaltyStub/LoyaltyConnect/LoyaltyConnect.css';
import Account from './components/Account/Account/Account.css';
import AccountModule from './components/Modules/Account/Account.css';
import LoginForm from './components/LoginPage/LoginForm/LoginForm/LoginForm.css';
import LoginPageCodeForm from './components/LoginPage/LoginForm/CodeForm/CodeForm.css';
import Welcome from './components/LoginPage/LoginForm/Welcome/Welcome.css';
import OrderCard from './components/OrderCard/OrderCard.css';
import CommonItem from './components/OrderCard/CommonItem/CommonItem.css';
import OrderPreview from './components/OrderCard/OrderPreview/OrderPreview.css';
import OrderBooking from './components/OrderCard/OrderBooking/OrderBooking.css';
import PaymentStatus from './components/OrderCard/PaymentStatus/PaymentStatus.css';
import OrderPassengers from './components/OrderCard/OrderPassengers/OrderPassengers.css';
import StayLoggedIn from './components/StayLoggedIn/StayLoggedIn.css';
const theme = {
    LoginPage: {
        StayLoggedIn: {
            rememberMe: StayLoggedIn.rememberMe
        }
    },
    OrderSummary: {
        OrderHeader: {
            manage: OrderSummary.manage,
            button: OrderSummary.button
        }
    },
    Traveller: {
        Traveller: {
            title__traveller: Traveller.title__traveller,
            add: Traveller.add
        }
    },
    Account: {
        Account: {
            account__offers: Account.account__offers,
            checkbox: Account.checkbox,
            checked: Account.checked
        },
        SocialButton: {
            social__buttons__control: SocialButton.social__buttons__control,
            add__icon: SocialButton.add__icon
        }
    },
    Sidebar: {
        Sidebar: {
            sidebar: Sidebar.sidebar,
            sidebar__item: Sidebar.sidebar__item,
            sidebar__item_selected: Sidebar.sidebar__item_selected,
            link: Sidebar.link,
            icon: Sidebar.icon
        },
        MobileMenu: {
            content: MobileMenu.content,
            menu__item_selected: MobileMenu.menu__item_selected,
            icon: MobileMenu.icon
        }
    },
    InfoCard: {
        InfoCard: {
            card_dummy: InfoCard.card_dummy,
            footer: InfoCard.footer
        }
    },
    Loyalty: {
        LoyaltyConnect: {
            buttons__wrapper: LoyaltyConnect.buttons__wrapper
        }
    },
    OrderCard: {
        OrderCard: {
            root: OrderCard.root,
            container: OrderCard.container,
            type_account: OrderCard.type_account,
            preview: OrderCard.preview
        },
        CommonItem: {
            root: CommonItem.root,
            account: CommonItem.account
        },
        OrderPreview: {
            city: OrderPreview.city,
            main_city: OrderPreview.main_city
        },
        OrderBooking: {
            root: OrderBooking.root,
            type_account: OrderBooking.type_account,
            icon: OrderBooking.icon
        },
        PaymentStatus: {
            root: PaymentStatus.root,
            icon: PaymentStatus.icon,
            account: PaymentStatus.account
        },
        OrderPassengers: {
            root: OrderPassengers.root,
            account: OrderPassengers.account,
            icon: OrderPassengers.icon
        }
    },
    AccountModule: {
        Account: {
            route__title: AccountModule.route__title,
            loginWrapper: AccountModule.loginWrapper
        }
    },
    LoginPage: {
        LoginForm: {
            root: LoginForm.root,
            title: LoginForm.title,
            social_title: LoginForm.social_title,
            button_wrapper: LoginForm.button_wrapper,
            input_wrapper: LoginForm.input_wrapper,
            row: LoginForm.row,
            social_wrapper: LoginForm.social_wrapper
        },
        CodeForm: {
            root: LoginPageCodeForm.root,
            title: LoginPageCodeForm.title,
            message: LoginPageCodeForm.message,
            button_wrapper: LoginPageCodeForm.button_wrapper,
            resend: LoginPageCodeForm.resend,
            input_wrapper: LoginForm.input_wrapper
        },
        Welcome: {
            title: Welcome.title
        }
    }
};
export default theme;
